import styles from "./Header.module.scss";
import {NavLink, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import selectArrow from "../../assets/images/icons/select-arrow-dark.svg";
import selectArrowBlue from "../../assets/images/icons/select-arrow-blue.svg";
import logoutIcon from "../../assets/images/icons/logout.svg";
import {useState} from "react";
import useAppSelector from "../../hooks/useAppSelector";
import {firstLetterToUpperCase, getLanguageFromLocal, languageList} from "../../helpers/language.helper";
import CustomButton from "../UI/CustomButton/CustomButton";
import {AuthService} from "../../services/auth.service";
import useAppDispatch from "../../hooks/useAppDispatch";
import {logout} from "../../store/profile/profileSlice";
import {getLogo, getProfileImage} from "../../helpers/image.helper";
import closeBurgerMenuIcon from "../../assets/images/icons/close-pupup-dark.svg";
import {SiteContentService} from "../../services/siteContent.service";
import {setSiteContent} from "../../store/siteContent/siteContentSlice";
import ConfirmPopup from "../ConfirmPopup/ConfirmPopup";
import LocationGymPopup from "../LocationGymPopup/LocationGymPopup";
import locationDarkSvg from "../../assets/images/icons/location-dark.svg";

const Header = () => {

    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {isAuthorized, profile} = useAppSelector(state => state.profileSlice);
    const {generalSettings} = useAppSelector(state => state.generaContentSettingsSlice);
    const {activeGym} = useAppSelector(state => state.multiGymsSlice);

    const [isLanguageSelectActive, setIsLanguageSelectActive] = useState<boolean>(false);
    const [burgerMenuActive, setBurgerMenuActive] = useState<boolean>(false);
    const [showConfirmSignOutPopup, setShowConfirmSignOutPopup] = useState<boolean>(false);
    // const [visibleLocationPopup, setVisibleLocationPopup] = useState<boolean>(false);


    const clickOnLogo = () => {
        navigate("/")
    }

    const clickOnLanguageBtn = () => {
        setIsLanguageSelectActive(!isLanguageSelectActive);
    }

    // const clickOnLocationButton = () => {
    //     setVisibleLocationPopup(true);
    // }

    const clickOnLanguageItem = (value: string) => {
        localStorage.setItem("selectedLanguage", value);
        i18n.changeLanguage(value);
        getSiteContent(value);
    }

    const clickOnLoginBtn = () => {
        navigate("/auth/login");
    }

    const clickOnSignUpBtn = () => {
        navigate("/auth/register")
    }

    const clickOnLogout = () => {
        setShowConfirmSignOutPopup(true);
    }

    const signOut = () => {
        AuthService.logout();
        dispatch(logout());
        navigate("");
        closeConfirmSignOutPopup();
        setBurgerMenuActive(false);
    }

    const closeConfirmSignOutPopup = () => {
        setShowConfirmSignOutPopup(false);
    }

    const openBurgerMenu = () => {
        setBurgerMenuActive(true);
    }

    const closeBurgerMenu = (event: any) => {
        event.stopPropagation();
        setBurgerMenuActive(false);
    }

    // const closeLocationGymPopup = () => {
    //     setVisibleLocationPopup(false);
    // }

    const getSiteContent = async (language: string) => {
        try {
            const response = await SiteContentService.getSiteContent(language);
            if (response.data && response.status === 200) {
                dispatch(setSiteContent(response.data));
            }
        } catch (e) {}
    }

    return (
        <>
            <header className={styles.header}>
                <div className={"container"}>
                    <div className={styles.wrapper}>
                        <div className={styles.left}>
                            <div className={styles.logo}>
                                <img onClick={clickOnLogo} src={getLogo(generalSettings.logoPath)}
                                     alt={"logo"}/>
                            </div>
                            <ul className={styles.menu}>
                                <li>
                                    <NavLink
                                        className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                        to={"/services"}
                                    >
                                        {t("Services")}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                        to={"/plans"}
                                    >
                                        {t("Plans")}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                        to={"/trainers"}
                                    >
                                        {t("Trainers")}
                                    </NavLink>
                                </li>
                                <li>
                                    <div
                                         className={`${styles.more}`}>
                                        <p>{t("More")}</p>
                                        <img src={selectArrow} alt={"arrow"}/>
                                        {
                                            (
                                                <div className={styles.fakeWrapper}>
                                                    <ul className={styles.moreDropDown}>
                                                        <li>
                                                            <NavLink
                                                                className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                                                to={"/schedule"}>
                                                                {t("Schedule")}
                                                            </NavLink>
                                                        </li>
                                                        <li>
                                                            <NavLink
                                                                className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                                                to={"/venues"}>
                                                                {t("Venues")}
                                                            </NavLink>
                                                        </li>
                                                        <li>
                                                            <NavLink
                                                                className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                                                to={"/about-us"}>
                                                                {t("AboutUs")}
                                                            </NavLink>
                                                        </li>
                                                        <li>
                                                            <NavLink
                                                                className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                                                to={"/contact-us"}>
                                                                {t("ContactUs")}
                                                            </NavLink>
                                                        </li>
                                                    </ul>
                                                </div>
                                            )
                                        }
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className={styles.right}>
                            {/*<button onClick={clickOnLocationButton} className={styles.locationBtn}>*/}
                            {/*    <img src={locationDarkSvg} alt={"location"}/>*/}
                            {/*</button>*/}
                            <div onClick={clickOnLanguageBtn}
                                 className={`${styles.language} ${isLanguageSelectActive && styles.languageActive}`}>
                                <p>{firstLetterToUpperCase(getLanguageFromLocal())}</p>
                                <img src={selectArrowBlue} alt={"arrow"}/>
                                {
                                    isLanguageSelectActive && (
                                        <ul className={styles.languageDropdown}>
                                            {
                                                languageList.map(el => {
                                                    return (
                                                        <li
                                                            onClick={() => clickOnLanguageItem(el.key)}
                                                            className={`${getLanguageFromLocal() === el.key && styles.activeLanguageItem}`}
                                                            key={el.key}
                                                        >
                                                            {el.label}
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    )
                                }
                            </div>
                            <div className={styles.userInfo}>
                                {
                                    isAuthorized && profile ? (
                                        <>
                                            <div onClick={() => navigate("/account")} className={styles.profileIcon}
                                                 style={{backgroundImage: `url(${getProfileImage(activeGym.endpoint, profile)})`}}></div>
                                            <img onClick={clickOnLogout} className={styles.logoutIcon} src={logoutIcon}
                                                 alt={"logout"}/>
                                        </>
                                    ) : (
                                        <div className={styles.btnsWrapper}>
                                            <CustomButton
                                                text={t("Login")}
                                                type={"button"}
                                                typeStyle={"fill"}
                                                borderRadius={false}
                                                functionOnClick={clickOnLoginBtn}
                                            />
                                            <CustomButton
                                                text={t("SignUp")}
                                                type={"button"}
                                                typeStyle={"outline"}
                                                borderRadius={false}
                                                functionOnClick={clickOnSignUpBtn}
                                                blueForOutline={true}
                                            />
                                        </div>

                                    )
                                }
                            </div>
                        </div>
                        <div className={`${styles.burger} ${burgerMenuActive && styles.active}`}
                             onClick={openBurgerMenu}>
                            <span></span>
                            <span></span>
                            <span></span>
                            <div className={styles.burgerDropdown}>
                                <div className={styles.burgerContent}>
                                    <button className={styles.close} onClick={closeBurgerMenu}>
                                        <img src={closeBurgerMenuIcon} alt={"close"}/>
                                    </button>

                                    <div className={styles.burgerWrapper}>

                                        <ul className={styles.burgerList}>
                                            <li>
                                                <NavLink
                                                    onClick={closeBurgerMenu}
                                                    className={prop => prop.isActive ? `${styles.burgerLink} ${styles.burgerLinkActive}` : `${styles.burgerLink}`}
                                                    to={"/services"}
                                                >
                                                    {t("Services")}
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    onClick={closeBurgerMenu}
                                                    className={prop => prop.isActive ? `${styles.burgerLink} ${styles.burgerLinkActive}` : `${styles.burgerLink}`}
                                                    to={"/plans"}
                                                >
                                                    {t("Plans")}
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    onClick={closeBurgerMenu}
                                                    className={prop => prop.isActive ? `${styles.burgerLink} ${styles.burgerLinkActive}` : `${styles.burgerLink}`}
                                                    to={"/trainers"}
                                                >
                                                    {t("Trainers")}
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    onClick={closeBurgerMenu}
                                                    className={prop => prop.isActive ? `${styles.burgerLink} ${styles.burgerLinkActive}` : `${styles.burgerLink}`}
                                                    to={"/schedule"}
                                                >
                                                    {t("Schedule")}
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    onClick={closeBurgerMenu}
                                                    className={prop => prop.isActive ? `${styles.burgerLink} ${styles.burgerLinkActive}` : `${styles.burgerLink}`}
                                                    to={"/venues"}>
                                                    {t("Venues")}
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    onClick={closeBurgerMenu}
                                                    className={prop => prop.isActive ? `${styles.burgerLink} ${styles.burgerLinkActive}` : `${styles.burgerLink}`}
                                                    to={"/about-us"}
                                                >
                                                    {t("AboutUs")}
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    onClick={closeBurgerMenu}
                                                    className={prop => prop.isActive ? `${styles.burgerLink} ${styles.burgerLinkActive}` : `${styles.burgerLink}`}
                                                    to={"/contact-us"}
                                                >
                                                    {t("ContactUs")}
                                                </NavLink>
                                            </li>
                                        </ul>

                                        <div
                                            className={`${styles.burgerLanguageWrapper} ${isLanguageSelectActive && styles.languageActive}`}
                                            onClick={clickOnLanguageBtn}>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M17.5907 14.6464C18.4487 13.2487 18.9018 11.6403 18.8995 10.0002C18.9018 8.36014 18.4487 6.75141 17.5907 5.35363L17.5859 5.34583C16.79 4.04847 15.6746 2.97692 14.3464 2.23355C13.0182 1.49019 11.5216 1.09985 9.99951 1.09985C8.47745 1.09985 6.98081 1.49019 5.65262 2.23355C4.32443 2.97692 3.20907 4.04847 2.41311 5.34583L2.40831 5.35363C1.55249 6.75235 1.09961 8.36026 1.09961 10C1.09961 11.6398 1.55249 13.2477 2.40831 14.6464L2.41331 14.6544C3.2093 15.9517 4.32467 17.0232 5.65285 17.7665C6.98103 18.5099 8.47764 18.9002 9.99967 18.9001C11.5217 18.9001 13.0183 18.5098 14.3465 17.7664C15.6746 17.0231 16.79 15.9516 17.5859 14.6542L17.5907 14.6464ZM11.1371 17.3746C10.9675 17.5383 10.7722 17.6731 10.5591 17.7738C10.3842 17.8569 10.193 17.9 9.99941 17.9C9.80579 17.9 9.6146 17.8569 9.43971 17.7738C9.03423 17.5667 8.68712 17.2613 8.43011 16.8854C7.90528 16.127 7.51635 15.283 7.28071 14.3912C8.18605 14.3355 9.09231 14.3071 9.99951 14.306C10.9063 14.306 11.8126 14.3344 12.7185 14.3912C12.5881 14.8497 12.4251 15.2983 12.2309 15.7336C11.9752 16.3459 11.6038 16.903 11.1371 17.3746ZM2.11691 10.5H5.70671C5.73011 11.5017 5.8387 12.4996 6.03131 13.4828C5.04998 13.5692 4.07118 13.6879 3.09491 13.8388C2.52316 12.8131 2.18895 11.6721 2.11691 10.5ZM3.09491 6.16143C4.07078 6.31263 5.04991 6.4313 6.03231 6.51743C5.83936 7.50058 5.73057 8.49839 5.70711 9.50003H2.11691C2.18898 8.328 2.52319 7.18709 3.09491 6.16143ZM8.86191 2.62543C9.03153 2.46175 9.22678 2.3269 9.43991 2.22623C9.6148 2.14314 9.80599 2.10003 9.99961 2.10003C10.1932 2.10003 10.3844 2.14314 10.5593 2.22623C10.9648 2.43334 11.3119 2.73878 11.5689 3.11463C12.0937 3.87311 12.4827 4.71708 12.7183 5.60883C11.813 5.66456 10.9067 5.69296 9.99951 5.69403C9.09271 5.69403 8.18638 5.66563 7.28051 5.60883C7.41097 5.15035 7.57391 4.70175 7.76811 4.26643C8.02383 3.6542 8.39521 3.09703 8.86191 2.62543ZM17.8821 9.50003H14.2923C14.2689 8.49836 14.1603 7.50049 13.9677 6.51723C14.949 6.43083 15.9278 6.31216 16.9041 6.16123C17.4759 7.18695 17.8101 8.32793 17.8821 9.50003ZM7.03711 13.405C6.84157 12.4483 6.73114 11.4762 6.70711 10.5H13.2921C13.2683 11.4763 13.1581 12.4485 12.9627 13.4052C11.976 13.3404 10.9883 13.3074 9.99951 13.306C9.01151 13.306 8.02405 13.339 7.03711 13.405ZM12.9619 6.59503C13.1574 7.55172 13.2679 8.52385 13.2919 9.50003H6.70711C6.73092 8.5238 6.84115 7.5516 7.03651 6.59483C8.02318 6.65963 9.01091 6.6927 9.99971 6.69403C10.9877 6.69403 11.9752 6.66096 12.9621 6.59483L12.9619 6.59503ZM14.2919 10.5H17.8821C17.8101 11.6721 17.4758 12.813 16.9041 13.8386C15.9281 13.6874 14.949 13.5688 13.9667 13.4826C14.1597 12.4995 14.2685 11.5017 14.2919 10.5ZM16.3045 5.24103C15.4512 5.3641 14.5954 5.46156 13.7371 5.53343C13.5829 4.95904 13.3839 4.39759 13.1421 3.85423C12.9213 3.35424 12.6435 2.88144 12.3141 2.44523C13.9056 2.93336 15.3022 3.91187 16.3045 5.24103ZM4.41351 4.41383C5.3265 3.49997 6.44972 2.82402 7.68471 2.44523C7.66591 2.46963 7.64671 2.49283 7.62831 2.51743C6.99351 3.43121 6.53111 4.45335 6.26391 5.53343C5.40551 5.46076 4.54911 5.3633 3.69471 5.24103C3.91504 4.94912 4.15521 4.67273 4.41351 4.41383ZM3.69471 14.759C4.54791 14.636 5.40371 14.5385 6.26211 14.4666C6.41636 15.041 6.61529 15.6025 6.85711 16.1458C7.07793 16.6458 7.35578 17.1186 7.68511 17.5548C6.09359 17.0667 4.69698 16.0882 3.69471 14.759ZM15.5859 15.5862C14.6729 16.5001 13.5497 17.176 12.3147 17.5548C12.3335 17.5304 12.3527 17.5072 12.3711 17.4826C13.0059 16.5688 13.4683 15.5467 13.7355 14.4666C14.5939 14.5393 15.4503 14.6368 16.3047 14.759C16.0844 15.0509 15.8442 15.3273 15.5859 15.5862Z"
                                                    fill="#353535"/>
                                            </svg>

                                            <p>{languageList.find(el => el.key === getLanguageFromLocal())?.label}</p>

                                            <img src={selectArrow} alt={"select"}/>

                                            {
                                                isLanguageSelectActive && (
                                                    <ul className={styles.languageDropdown}>
                                                        {
                                                            languageList.map(el => {
                                                                return (
                                                                    <li
                                                                        onClick={() => clickOnLanguageItem(el.key)}
                                                                        className={`${getLanguageFromLocal() === el.key && styles.activeLanguageItem}`}
                                                                        key={el.key}
                                                                    >
                                                                        {el.label}
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                )
                                            }

                                        </div>

                                        <div className={styles.userInfo}>
                                            {
                                                isAuthorized && profile ? (
                                                    <>
                                                        <div onClick={() => navigate("/account")}
                                                             className={styles.profileIcon}
                                                             style={{backgroundImage: `url(${getProfileImage(activeGym.endpoint, profile)})`}}></div>
                                                        <img onClick={clickOnLogout} className={styles.logoutIcon}
                                                             src={logoutIcon} alt={"logout"}/>
                                                    </>
                                                ) : (
                                                    <div className={styles.btnsWrapper}>
                                                        <CustomButton
                                                            text={t("Login")}
                                                            type={"button"}
                                                            typeStyle={"fill"}
                                                            borderRadius={false}
                                                            functionOnClick={clickOnLoginBtn}
                                                        />
                                                        <CustomButton
                                                            text={t("SignUp")}
                                                            type={"button"}
                                                            typeStyle={"outline"}
                                                            borderRadius={false}
                                                            functionOnClick={clickOnLogout}
                                                            blueForOutline={true}
                                                        />
                                                    </div>

                                                )
                                            }
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {/*{*/}
            {/*    visibleLocationPopup && (*/}
            {/*        <LocationGymPopup*/}
            {/*            fromApp={false}*/}
            {/*            closePopupFn={closeLocationGymPopup}*/}
            {/*        />*/}
            {/*    )*/}
            {/*}*/}
            {
                showConfirmSignOutPopup && (
                    <ConfirmPopup text={t("AreYouSureYouWantToLogout")} clickOnYes={signOut} clickOnCancel={closeConfirmSignOutPopup}/>
                )
            }
        </>

    )
}

export default Header;